import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import dayjs from 'dayjs';
import locale_de from 'dayjs/locale/de';
import updateLocale from 'dayjs/plugin/updateLocale';
import { ButtonModule } from 'primeng/button';
import { MenubarModule } from 'primeng/menubar';
import { ToastModule } from 'primeng/toast';
import { EnvironmentBanner } from './components/environment-banner/environment-banner';
@Component({
  selector: 'app-root',
  imports: [ButtonModule, EnvironmentBanner, MenubarModule, RouterOutlet, ToastModule],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {

  constructor() {
    dayjs.locale(locale_de);
    dayjs.extend(updateLocale);
  }


}

